import { render, staticRenderFns } from "./PersonalPolicy.vue?vue&type=template&id=0fbf310c&scoped=true&"
import script from "./PersonalPolicy.vue?vue&type=script&lang=js&"
export * from "./PersonalPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PersonalPolicy.vue?vue&type=style&index=0&id=0fbf310c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf310c",
  null
  
)

export default component.exports